import React from 'react'
import PropTypes from 'prop-types'

import AccessibleFormLabel from '../AccessibleFormLabel'
import SingleSelectField from './SingleSelectField'

const SingleSelect = props => {
  const singleSelectField = (
    <SingleSelectField
      meta={props.meta}
      input={props.input}
      name={props.name}
      label={props.innerLabel}
      value={props.value}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      dataTest={props.dataTest}
      onSelect={props.onSelect}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      helpText={props.helpText}
      tabIndex={props.tabIndex}
      theme={props.theme}
      id={props.id}
      className={props.selectClassName}>
      {props.children}
    </SingleSelectField>
  )

  if (!props.label) return singleSelectField

  return (
    <AccessibleFormLabel
      formFieldId={props.id}
      label={props.label}
      labelClassName={props.labelClassName}
      readOnly={props.readOnly}
      optional={props.optional}>
      {singleSelectField}
    </AccessibleFormLabel>
  )
}

SingleSelect.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  name: PropTypes.string,
  innerLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  dataTest: PropTypes.string,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  helpText: PropTypes.string,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info', 'light']),
  selectClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  id: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  optional: PropTypes.bool,
}

export default SingleSelect
